import React, { ReactElement } from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Platform } from 'src/libs/platform';

type Props = {
  vertical?: boolean;
  horizontal?: boolean;
  left?: boolean;
  right?: boolean;
  top?: boolean;
  bottom?: boolean;
  respectInsets?: boolean;
  children: ReactElement;
};

const padding = Platform.select({ ios: 12, android: 16, default: 16 });

export const PlatformPadding: React.FC<Props> = ({
  children,
  vertical = false,
  horizontal = false,
  left = false,
  right = false,
  top = false,
  bottom = false,
  respectInsets = false,
}) => {
  const insets = useSafeAreaInsets();

  const styles = [
    horizontal && {
      paddingLeft: respectInsets ? Math.max(insets.left, padding) : padding,
      paddingRight: respectInsets ? Math.max(insets.right, padding) : padding,
    },
    vertical && {
      paddingTop: respectInsets ? Math.max(insets.top, padding) : padding,
      paddingBottom: respectInsets ? Math.max(insets.bottom, padding) : padding,
    },
    left && {
      paddingLeft: respectInsets ? Math.max(insets.left, padding) : padding,
    },
    right && {
      paddingRight: respectInsets ? Math.max(insets.right, padding) : padding,
    },
    top && {
      paddingTop: respectInsets ? Math.max(insets.top, padding) : padding,
    },
    bottom && {
      paddingBottom: respectInsets ? Math.max(insets.bottom, padding) : padding,
    },
  ];

  return React.cloneElement(React.Children.only(children), {
    style: [styles, children.props.style],
  });
};
